<template>
  <el-dialog
    :visible="true"
    width="1100px"
    @close="$router.replace('/reports/storage-stock')"
    :close-on-click-modal="false"
  >
    <div
      slot="title"
    >
      {{ title }}
    </div>
    <el-tabs
      v-model="activeName"
      >

      <el-tab-pane
        label="Készlet"
        name="1"
        v-loading="loading"
      >
        <el-input
          v-model="filterInput"
          class="filter-input"
          size="small"
          style="margin-bottom: 15px; width: 230px"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
          />
        </el-input>
        <el-table
          :data="filteredStockData"
          border
          class="stock-table"
          @expand-change="onExpandRow"
          :default-sort="{prop: 'storage_name',order: 'ascending'}"
        >
          <el-table-column
            type="expand"
          >
            <template slot-scope="scope">
              <div
                v-loading="stockLoading === scope.row.id"
                style="margin: -20px 0px;"
              >
                <div v-if="stocks.find(s => s.storage_id === scope.row.id)">
                  <el-card
                    v-for="stock in stocks.find(s => s.storage_id === scope.row.id).packs"
                    v-if="stock.count"
                    :key="stock.id"
                    style="margin: 20px 0;"
                  >
                    <div
                      slot="header"
                    >
                      <strong>{{ stock.count }} <span v-if="stock.count_per_pack === 1">db</span><span v-else>{{ stock.pack_type.name }}</span></strong><span v-if="stock.count_per_pack !== 1"> ({{ stock.count * stock.count_per_pack }} db)</span>
                      <el-tag
                        v-if="stock.count_per_pack !== 1"
                        size="small"
                        type="info"
                        style="display: inline-block; float: right; margin-top: -3px;"
                      >
                        {{ stock.count_per_pack }} db / {{ stock.pack_type.name }}
                      </el-tag>
                    </div>
                    <h4 style="margin-top: 0;">Beszállítók / Szavatossági idők szerinti készlet</h4>
                    <div
                      v-for="supplier in stock.suppliers"
                      v-if="supplier.count"
                      :key="supplier.id"
                    >
                      {{ supplier.company.name }}<i class="el-icon-d-arrow-right" style="margin: 0 5px;"></i><strong>{{ supplier.count }} <span v-if="stock.count_per_pack === 1">db</span><span v-else>{{ stock.pack_type.name }}</span></strong><span v-if="stock.count_per_pack !== 1"> ({{ stock.count *  stock.count_per_pack }} db)</span></strong>
                      <ul>
                        <li
                          v-for="expiration in supplier.expirations"
                          :key="expiration.id"
                          style="line-height: 1.5;"
                        >
                          {{ expiration.expiration_date | date }}<i class="el-icon-d-arrow-right" style="margin: 0 5px;"></i><strong>{{ expiration.count }} <span v-if="stock.count_per_pack === 1">db</span><span v-else>{{ stock.pack_type.name }}</span></strong><span v-if="stock.count_per_pack !== 1"> ({{ expiration.count * stock.count_per_pack }} db)</span>
                        </li>
                      </ul>
                    </div>
                  </el-card>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Raktár"
            prop="storage_name"
            class-name="product-column"
            min-width="200"
            sortable
          />
          <el-table-column
                  label="Saját készlet"
                  prop="own_stock"
                  width="170"
                  sortable
          >
            <template slot-scope="scope">
              {{ scope.row.own_stock }} db
            </template>
          </el-table-column>
          <el-table-column
                  label="Tervezett készlet"
                  prop="supplier_order_stock"
                  width="170"
                  sortable
          >
            <template slot-scope="scope">
              {{ scope.row.supplier_order_stock }} db
            </template>
          </el-table-column>
          <el-table-column
                  label="Foglalt készlet"
                  prop="customer_order_stock"
                  width="170"
                  sortable
          >
            <template slot-scope="scope">
              {{ scope.row.customer_order_stock }} db
            </template>
          </el-table-column>

          <el-table-column
                  label="Felhasználható készlet"
                  prop="available_stock"
                  width="220"
                  sortable
          >
            <template slot-scope="scope">
              {{ scope.row.available_stock }} db
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane
              name="2"
      >
        <span slot="label">Teljesítetlen beszállítói megrend. <i class="el-icon-loading" v-if="supplierOrderLoading"></i><span v-else>({{ supplierOrders.length }})</span></span>
        <supplier-order></supplier-order>
      </el-tab-pane>
      <el-tab-pane
              name="3"
      >
        <span slot="label">Teljesítetlen vevői megrend. <i class="el-icon-loading" v-if="customerOrderLoading"></i><span v-else>({{ customerOrders.length }})</span></span>
        <customer-order></customer-order>
      </el-tab-pane>
      <el-tab-pane
              name="4"
      >
        <span slot="label">Teljesítetlen képviselői megrend. <i class="el-icon-loading" v-if="representativeOrderLoading"></i><span v-else>({{ representativeOrders.length }})</span></span>
        <representative-order></representative-order>
      </el-tab-pane>
    </el-tabs>

    </div>
  </el-dialog>
</template>

<script>

import SupplierOrder from "./SupplierOrder";
import CustomerOrder from "./CustomerOrder";
import RepresentativeOrder from "./RepresentativeOrder";
export default {
  components: {SupplierOrder, CustomerOrder, RepresentativeOrder},
  props: ['productId'],
  data() {
    return {
      stockData: [],
      stocks: [],
      activeName: '1',
      stockLoading: 0,
      filterInput: '',
      title: 'Betöltés folyamatban...',
      loading: false,
    };
  },

  async created() {
    this.fetchData();
    if (!this.$store.state.storageStockReport.storageInDialog) {
      await this.$store.dispatch('storage/fetchAll');
      this.$store.commit('storageStockReport/setStorageInDialog', this.storages.find(s => s.type === 'own'));
    }
    this.$store.commit('storageStockReport/setProductId', this.productId);
    this.$store.commit('storageStockReport/setStorageInDialog', this.$store.state.storageStockReport.storage);
    this.$store.dispatch('storageStockReport/fetchUnaccomplished');
  },
  methods: {
    async onExpandRow(row) {
      this.stockLoading = row.id;
      const stocks = await axios.get(`/api/products/${this.productId}/storage/${row.id}`);
      this.stocks.push(stocks);
      this.stockLoading = 0;
    },

    async fetchData() {
      this.loading = true;
      this.product = await axios.get(`api/products/${this.productId}`);
      await this.fetchStockData();
      this.title = this.product.name;
      this.loading = false;
    },

    async fetchStockData() {
      this.stockData = await axios.get(`/api/reports/storage-stock/products/${this.productId}`);
    },

    async handleSortChange({column, prop, order}) {
      this.loading = true;
      this.sort.prop = prop;
      this.sort.order = order;
      // await this.fetchStockData();
      this.loading = false;
    },

  },

  computed: {
    filteredStockData() {
      let array = this.stockData.filter(data => data.storage_name.toLocaleLowerCase()
              .indexOf(this.filterInput.toLocaleLowerCase()) !== -1);
      return array;
    },

    supplierOrderLoading() {
      return this.$store.state.storageStockReport.supplierOrderLoading;
    },

    customerOrderLoading() {
      return this.$store.state.storageStockReport.customerOrderLoading;
    },

    representativeOrderLoading() {
      return this.$store.state.storageStockReport.representativeOrderLoading;
    },

    supplierOrders() {
      return this.$store.getters['storageStockReport/supplierOrders'];
    },

    customerOrders() {
      return this.$store.state.storageStockReport.customerOrders;
    },

    representativeOrders() {
      return this.$store.state.storageStockReport.representativeOrders;
    },

    storages() {
      return this.$store.getters['storage/storages'];
    },
  }
};
</script>
<style lang="scss">
  .stock-table {
    .product-column {
      .cell {
        word-break: break-word;
      }
    }
  }

</style>

